import React, { useState } from 'react';
import Header from '../Header';
import Sidebar from '../Sidebar';
import PaidTrafficLog from './PaidTrafficLog';

const PaidTrafficLogLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Open the Paid Traffic group by default — you are inside it.
  const [openMenus, setOpenMenus] = useState({
    paidTraffic: true,
    competitorResearch: false,
    messages: false,
    support: false,
    settings: false
  });
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const toggleMenu = (menuKey) => {
    setOpenMenus((prev) => ({ ...prev, [menuKey]: !prev[menuKey] }));
  };

  return (
    <div className="min-h-screen bg-gray-50 text-sm transition-all duration-300 dark:bg-slate-950">
      <Sidebar
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        openMenus={openMenus}
        toggleMenu={toggleMenu}
      />
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-16' : 'ml-64'}`}>
        <Header
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          notifications={notifications}
          setNotifications={setNotifications}
          showNotifications={showNotifications}
          setShowNotifications={setShowNotifications}
          showProfileDropdown={showProfileDropdown}
          setShowProfileDropdown={setShowProfileDropdown}
        />
        <div className="p-6">
          <PaidTrafficLog />
        </div>
      </div>
    </div>
  );
};

export default PaidTrafficLogLayout;
